module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapnum"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Ship")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("The Kriegsmarine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 30 January 1933, Adolf Hitler took office as chancellor of a right-wing coalition government in Berlin. The C-in-C of the German Navy, Admiral Erich Raeder, met his new head of government for the first time on 2 February, when Hitler addressed senior officers during a dinner. In a subsequent private meeting some weeks later, Raeder was assured he would have time to re-build the Navy before any war erupted. The two appear to have struck a friendly note at first and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führer")]), _vm._v(" was willing to listen to the admiral and accept his advice in naval matters. Arguably not a hardened National Socialist, unlike many colleagues in the senior officer corps, Raeder nevertheless used the powers of the Nazi regime to the utmost for his Navy, realising that he could not have one without the other. Most probably he believed – or at least hoped – that the sharp edges of the new regime would wear off with time. In August 1934, the elderly head of state President Hindenburg died, and Hitler declared himself president in addition to chancellor, combining the two offices of state with full dictatorial powers. A few days later, all officers of the armed forces were paraded and ordered to pledge an oath of allegiance to Hitler in person. In a speech on Heroes’ Memorial Day, 16 March 1935, Hitler repudiated the Versailles Treaty and declared that Germany would resume its full sovereign powers. Compulsory conscription and military service for all young men was reintroduced and the resurrection of the German armed forces commenced. Two months later, the Navy was ominously renamed the Kriegsmarine and the German shipyards started to plan for full production.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 27 January 1938, Hitler issued a decree declaring himself Commander-in-Chief of the armed forces. The authority would be exercised through a new joint high command – Oberkommando der Wehrmacht (OKW) – that oversaw the separate high commands of the country’s armed services. OKW was in effect to be Hitler’s personal staff, combining strategic, operational and ministerial functions. Generaloberst Wilhelm Keitel was head of OKW with Generalmajor Alfred Jodl as his deputy and leader of the Operations Staff – Führungsstab. In April 1939, Raeder was promoted to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Großadmiral")]), _vm._v(", Grand Admiral, but it appears that he, and thus the Kriegsmarine, increasingly lost "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("touch with Nazi reality during this period. The Navy was gradually excluded from the inner circles of the Third Reich and Raeder would only be invited to meetings that had naval affairs on the agenda."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn1",
      "id": "ch1fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg2img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0002-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Commander-in-Chief of the German Navy, Admiral Erich Raeder, Oberbefehlshaber der Marine und Chef der Seekriegsleitung among his men on board "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scharnhorst")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The headquarters of the Navy High Command – Oberkommando der Marine (OKM) including Raeder – had its offices at Tirpitzufer in Berlin, next to the Landwehr Canal. The Naval Warfare Command – Seekriegsleitung (SKL) – responsible for planning and execution of naval operations as well as intelligence, administration and construction, was directly subordinated to OKM. The Chief of Staff of the SKL, Konteradmiral Otto Schniewind, a reserved, analytical and meticulous officer, was Raeder’s right-hand man. Under the SKL, Naval Group Command West – Marinegruppenkommando West – with its headquarters at Sengwarden near Wilhelmshaven under the command of Generaladmiral Alfred Saalwächter, oversaw operations in the Heligoland Bight, the North Sea and the Norwegian Sea while Naval Group Command East – Marinegruppenkommando Ost – under Admiral Rolf Carls covered the Baltic from headquarters in Kiel. The naval group commands had on paper operational control within their areas of command, but OKM and SKL would routinely intervene, either directly or through strict, detailed orders. Flottenchef or C-in-C Fleet was Generaladmiral "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Hermann Boehm with headquarters in Kiel. During major operations the Flottenchef was usually at sea as task-force commander, on board one of the capital ships. Shortly after the outbreak of war in 1939, Boehm fell out with Saalwächter, and was replaced by Admiral Wilhelm Marschall. At the same time, the command of the Flottenchef was limited to the capital ships and separate commands established for cruisers, destroyers, torpedo boats and other functional groups of ships"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(" The submarine headquarters under Befehlshaber der Unterseeboote (BdU) Konter admiral Karl Dönitz, also at Sengwarden in early 1940, had significant operational freedom. Most minesweepers and patrol boats were under harbour security command at this stage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new ships needed crews, and a large-scale recruitment campaign was initiated while many petty officers and warrant officers were promoted and some commissioned, preparing for expansion. This was good for them, but awkward for the Kriegsmarine, which lost the backbone of its organisation and had to train new petty officers amidst increased competition for the best candidates from the other services. As war drew close, a large number of auxiliaries and support ships were requisitioned, and the lack of experienced officers became even worse."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn2",
      "id": "ch1fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg3map1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0003-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Loopholes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Treaty of Versailles reduced Germany’s military forces to a minimum after World War 1. The Navy was reduced to eight out-dated pre-Dreadnought battleships, a similar number of old cruisers and about fifty destroyers, torpedo boats, minesweepers and other smaller vessels. No U-boats were allowed. The programme for new builds was strictly limited, and only in 1927 did the light cruiser "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Emden")]), _vm._v(" enter service as the first new ship in a decade. She was robust and functional, but a top speed of 29.5 knots and single 15-cm guns in shielded mountings made her obsolete almost from the day of her launch. The Design Office announced her as displacing 5,400 tons, some 600 tons less than allowed, using all possible loopholes, including the ambiguity between tons and long tons, to the full. In fact, her standard displacement exceeded 6,950 tons, well over the limit. The Allied Control Commission failed to condemn this and, once played successfully, these tricks were exploited in all future designs until limits were altogether ignored."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn3",
      "id": "ch1fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg4img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Konteradmiral Otto Schniewind, Chief of Staff of the SKL or Naval Warfare Command.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Designing an efficient capital ship with no more than 28-cm guns within the 10,000-ton displacement limit created even bigger challenges. The first, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland,")]), _vm._v(" was not only the first German ship to carry triple turrets and aircraft catapults she was also the first capital ship in any navy with solely diesel propulsion: four engines per shaft. It was intended she should outgun all faster ships and outrun any with larger guns, but a maximum speed of only 28 knots would make the latter somewhat of a challenge, even if few Allied capital ships in commission at the time could catch her. Launched in May 1931, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" was initially classified by the Kriegsmarine as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panzerschiff")]), _vm._v(" or ‘armoured ship’. Officially within the 10,000-ton limit, she was nonetheless close to 15,000 tons when loaded. The British Admiralty looked at her with some concern, but though fast, she and her two sisters were not fast enough "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("and with unreliable engines and poor performance in heavy seas, they never achieved what was expected of them. Up to seven additional similar ships were planned, but only "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Scheer")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Graf Spee")]), _vm._v(" were completed. Proper capital ships were needed, and the engineers of the Design Office were sent back to the drawing board. Redesign took time and only in May and June of 1935 were the keels of the battleships "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gneisenau")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scharnhorst")]), _vm._v(" laid down. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tirpitz")]), _vm._v(" would follow, but not be operational until 1941 and 1942 respectively, by which time their value was doubtful."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn4",
      "id": "ch1fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg5img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The light cruiser "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Emden")]), _vm._v(". She was essentially a WW1 design. Mixed oil and coal firing and a twin-shaft single-reduction geared turbine gave her a mediocre top speed and the eight 15-cm guns in shielded single mountings were an equally antiquated arrangement – but were the only guns available at the time of completion.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The making of a destroyer force was started with the six ships of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Raubvogel")]), _vm._v(" class. The first, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Möwe")]), _vm._v(", was launched in March 1926. Armed with three 10.5-cm guns, six torpedo tubes and capable of a fair 34 knots, they were primarily designed for torpedo attacks but also equipped for minelaying and coastal escort duties. Six subsequent ships of the slightly larger and faster "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Raubtier")]), _vm._v(" class were commissioned between October 1928 and August 1929. All these vessels were later reclassified as torpedo boats, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torpedoboote")]), _vm._v(". True destroyers would not be available for several years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the Kriegsmarine, the war with Britain came several years too early. Raeder had to revise all his plans and accept that resources would have to be spent on building far more U‐boats than he had foreseen. The Kriegsmarine could not sustain another humiliating and passive existence as in the previous war. He could not leave the fighting to the Army and Luftwaffe, the new air force. The Royal Navy had been neglected during the 1930s but remained a major challenge, and it would be crucial to find ways of operating with the ships at hand while making those in the pipeline ready for war. If the British "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("gained the upper hand, the German surface fleet would be degraded to small ships and submarines.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg6img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" in Sognefjord, western Norway, April 1934. Hitler was on board for this voyage. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" was renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lützow")]), _vm._v(" after returning from her first war cruise in 1939. Hitler decided it was unacceptable that a ship named ‘Germany’ might be sunk.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the eve of WW2, the Kriegsmarine had in commission two battleships, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scharnhorst")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gneisenau")]), _vm._v(", two old battleships, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schlesien")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schleswig-Holstein")]), _vm._v(", three "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panzerschiffe")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Graf Spee, Admiral Scheer")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" – one heavy cruiser, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Hipper")]), _vm._v(", six light cruisers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Emden")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leipzig")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nürnberg")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Köln")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karlsruhe")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Königsberg")]), _vm._v(", thirty-four destroyers and large torpedo boats, fifty-seven U-boats and some forty other small vessels. Within weeks, virtually all building of large surface ships, except those near completion, was suspended to focus on U-boats and smaller vessels. In the end, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tirpitz")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prinz")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eugen")]), _vm._v(" were the only ships larger than destroyers to be commissioned by the Kriegsmarine after the outbreak of the war. Germany’s first aircraft carrier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Graf Zeppelin")]), _vm._v(", was launched in late 1938, but work was suspended in 1940 and she ended up as a useless hulk."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn5",
      "id": "ch1fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Heavy Cruisers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most of the German naval staff considered cruisers essential in the Baltic as well as the North Sea and the Atlantic, and vital resources were spent designing and building such ships. The light cruisers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karlsruhe")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Königsberg")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Köln")]), _vm._v(" commissioned between February 1929 and January 1930, displaced 6,650 tons standard, an undeniable breach of the Versailles Treaty, followed by a further two with modified designs. The Anglo-German Naval Agreement of 18 June 1935 limited the German Navy to 35 per cent of the British strength prescribed by the treaties. This prevented the construction of additional ‘armoured cruisers’ but allowed for five modern heavy cruisers. Orders for the first two, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Hipper")]), _vm._v(", were placed in secrecy by the Kriegsmarine in October 1934 at Deutsche Werke in Kiel and Blohm & Voss in Hamburg respectively. In parallel, a development and construction contract was awarded to the Krupp company for 20.3-cm (8-inch) main guns and turrets, which was the largest calibre allowed on cruisers according to the Washington Treaty. Following the design specifications of the treaty, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Hipper")]), _vm._v(" was officially 10,000 tons when taken into service. In reality she had a displacement of 14,247 tons standard and 18,208 tons full load, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" a few hundred tons more.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg7img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Hitler visiting the bridge of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschland")]), _vm._v(" during the 1934 voyage. He was no naval enthusiast at all, and rumour had it that he quickly became seasick and locked himself away in his cabin.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Admiral Hipper")]), _vm._v(" was commissioned in April 1939. As was the case for most large German ships, the forecastle was found to be very wet, even in moderate seas. During a refit in late 1939, a raked ‘Atlantic’ clipper bow was fitted, the bridge improved, and a funnel cap added to prevent smoke invading the "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("bridge platforms. This made her a very hand some, efficient-looking ship – and very difficult to distinguish from the battleships at a distance: a problem the Royal Navy and RAF Coastal Command would face several times. These modifications were fitted to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" before she was commissioned on 20 September 1939. When released from the yard in Kiel on 30 March 1940, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" displaced 14,224 tons standard, and 18,694 tons fully loaded. She was 195 m (640 ft) long at the waterline and with the clipper bow, her overall length was 205.9 m (676 ft). She was designed primarily for surface warfare, but also had some anti-aircraft, anti-submarine, mine warfare, and signals intelligence capabilities.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg8img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The launch of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" on 8 June 1937.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v("’s main armament for surface warfare comprised eight 20.3-cm C/34 guns in twin turrets, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anton")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bruno,")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Caesar")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dora")]), _vm._v(" from bow to stern in German terminology. All guns were provided with high-explosive, armour-piercing and semi-armour-piercing (HE, AP, SAP) rounds and the magazines for B and C turrets also had star shells. The 122-kg shells were fired using a two-part propellant charge, rate of fire being four rounds per gun per minute with an effective range of 25,000 metres. The turrets revolved electrically, as part of the electro-hydraulic system. Otherwise, turrets, hoists, breeches and loaders were operated hydraulically. Turret "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anton")]), _vm._v(" had restrictions on firing directly ahead at low elevations (for ranges less than 5,000 metres) due to the raised forecastle.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg9img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The commissioning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" on 20 September 1939. The captain, Kapitän zur See Woldag, enters his ship in splendid solitude.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v("’s secondary armament consisted of twelve 10.5-cm C/33 multipurpose guns in six stabilised twin mountings produced by Rheinmetall. These guns had a maximum range of 17,000 metres, with an effective range of 12,000 metres, using 26.5-kg fixed ammunition with a shell weight of 15.1 kg. The firing rate per gun was 15–18 rounds per minute. Both types of guns were efficient and robust, although the 10.5-cm mounts had some electrical problems due to insufficient attention to watertightness."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn6",
      "id": "ch1fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Usually, bearing and elevation for the 20.3-cm and 10.5-cm guns were received from one of the centralised, gyro-stabilised fire-control directors or from the centrally controlled data and firing system connected to the calculators. The director was connected to an order-transmission unit and a fire-control transmitter passing information to one of the two fire-control centres, fore and aft. Both centres used a position-keeping calculator and a ballistic calculator, deep in the ship. Any director could provide data to the guns of the main or secondary armament, as well as the torpedoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an emergency the guns could be aimed directly at the target by the trainer at the telescopic sights. B and C turrets had their own rangefinders, but the rest of the guns depended on central rangefinders, or as a last resorts, assessments done by the gun commander supported by telescopic sights or binoculars. There were four 7-metre horizontal, stereoscopic rangefinders, one on the foretop tower, one at the aft fire-control and one each on B and C turrets. In addition, one 6-metre rangefinder was in the forward fire-control centre. Switching between directors, calculators and local control was unproblematic. Each fire control could take over from any of the others should they fall out. It was also possible to divide the 20.3-cm battery to engage two targets simultaneously using different directors.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg10img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Members of each "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Korporalschaft")]), _vm._v(" lining up to collect food for the whole group.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg10img2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("There were no common canteens or dining rooms on board and men ate and spent off-duty time with their mess or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Korporalschaft")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Entering combat, the captain would use a target finder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zielsäule,")]), _vm._v(" literally a ‘target column’ or aiming post, on the open bridge to point out his chosen target to the gunnery officers. The main weapons would be directed by one of the gunnery officers. The First Gunnery Officer, I. Artillerieoffizier or I. AO, was usually in the forward fire-control in the foretop or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vormarsstand")]), _vm._v(" above the bridge. The navigation bridge, the wheelhouse and the forward fire-control centre were co-located in front of the tower, above the B-turret. Both navigation and combat management took place from the vessel’s bridge, either from the open part, the wheelhouse or from inside the armoured citadel. The admiral’s bridge was in the middle of the forward tower but had no instruments for navigation or fire-control. The Fourth Gunnery Officer (IV. AO) was in the forward fire-control centre behind the navigation bridge. Outside, between the tower and the fire-control centre, there were on both sides of the ship directors for guns, star-shells, searchlights and torpedoes. The Third Gunnery Officer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(")]), _vm._v("III. AO) usually had his station in the aft fire-control centre behind C turret with similar directors as forward. Each gunnery officer handled a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zielgeber")]), _vm._v(" fire-control director, assisted by two men. Their preferred method was usually salvo-firing and to hit the target, a ‘ladder’ was first fired – three salvos spaced 400 metres apart – or alternatively ranging shots – ‘bracketing’. Rapid salvos were then ordered when the target was straddled or hit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 10.5-cm guns were also part of the anti-aircraft system (AA) controlled by the Second Gunnery Officer (II. AO) had his normal position in the anti-aircraft control centre in the tower with two gun-target columns. The forward AA directors for the 10.5-cm guns were designated A (starboard) and B (port), the after directors C (starboard) and D (port). Starboard 10.5-cm mounts were known as Stb I, Stb II and Stb. III – and similarly on the port side. The light anti-aircraft armament included twelve twin-mounted 3.7-cm guns and eight single 2-cm guns, better than many contemporary ships. The 3.7-cm gun was semi-automatic with a rate of fire of up to 80 rounds per barrel per minute. The novel gyro-stabilisation was effective, though not perfect. The 2-cm gun was fully automatic but manually trained and elevated with hand wheels. It had a theoretical rate of fire of 280 rounds per minute. In practice, though, it fired at around 180 rpm due to an inadequate magazine design. The 10.5-cm guns had a rather low rate of fire but, supplemented by 3.7-cm, and 2-cm guns, they gave the cruiser a potent anti-aircraft defence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was equipped with a Funkmess-Ortung radar FuMO22, which was a well-kept secret. The two 6-metre mattress aerials of the FuMO22 set were mounted on the rangefinder cupola above the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vormarsstand")]), _vm._v(" and could not rotate independently of the cupola. Radar was in its infancy when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was built and the type on board could only track one object at a time. Its main use was ranging of targets detected visually. Accuracy was poor and it did not work properly near a coastline or in fjords. Blind-firing by radar was not possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up to three Arado Ar-196 floatplanes could be carried for scouting, reconnaissance and spotting for the artillery. The crew consisted of a pilot and a navigator/gunner. Each aircraft could carry two 50-kg bombs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were two separate hydrophone systems on board for passive underwater listening in addition to an active S-Geräte sonar. This was not as effective as the comparable British system known as asdic. Twelve torpedo tubes completed the offensive surface armament in two triple mounts on each side. The torpedoes could be aimed and fired from two torpedo directors in the forward fire-control centre or secondary directors further aft. Each G7a torpedo had a warhead of 280 kg of TNT. At 40 knots, the range was 7,500 metres. Four to six depth-charges on the quarterdeck could be fired electronically. Mines and tracks for minelaying equipment could be carried but were normally kept ashore. Paravanes aboard were for self-protection use in areas threatened by mines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Signals warfare and intelligence was restricted in 1940. Very High Frequency VHF – Ultrakurzwelle (UKW) – radio-telephone communication between ships had become an integral part of the Kriegsmarine’s battle "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("management. This was normally excellent as it had a very short range and could be used between ships at sea without being intercepted or used for direction-finding by the enemy. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was well equipped with electronic equipment and had four radio rooms. Radio room A housed personnel of the cryptanalysis and monitoring service known as the Beobachtungsdienst or B-dienst. Most large ships had B-dienst units on board, which in addition to encoding and decoding own messages were expert in reading enemy signals, monitoring broadcasts, jamming and sending of fake signals.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg12img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The hull of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was subdivided into 14 sections by bulkheads; these sections were numbered from stern to bow.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v("’s hull was constructed of longitudinal steel frames with an inner and an outer part. There were numerous frames and bulkheads as well as an armoured intermediate deck along the entire length of the ship reinforcing the structure. A double bottom extended over 72 per cent of the keel. The inner hull was separated into fourteen watertight sections by transverse bulkheads or hull frames. These "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abteilungen")]), _vm._v(" were numbered with Roman numerals from stern to bow, thus Abt. I was the aftermost hull section while Abt. IX and X were under the forward fire-control centre and bridge. Bulkheads or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spanten")]), _vm._v(" were numbered in Arabic numerals also from stern to bow"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ship had five main decks, bottom to top: lower platform deck, upper platform deck, armoured deck, battery deck and the main deck with the superstructure and guns. On the main deck between turrets A and D there were compartments for the sick bay, torpedo and artillery maintenance, the aircraft hangar, galleys for seamen and officers and the officers’ mess. Accommodation for officers and seamen was located on the battery deck and the armoured deck. The armoured deck provided protection for the magazines and propulsion systems. The 80-mm thick belt armour covering the sides of the ship had a height of 3.8 metres and went 1.7 metres below the waterline. The main turrets had 70–160 mm armour, the conning tower 50–150 mm, and the bulkheads 20 mm. The main deck had 12–30 mm while the armoured deck had 20–50 mm. Like most other contemporary cruisers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was vulnerable to shells hitting from above. Steering was controlled by a single rudder and the ship had three shafts, each with a three-bladed propeller.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "pg14img1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" as she appeared in April 1940. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abram Joslin")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Engines, turbines, boilers and electrical generator compartments were distributed from sections II to IX, also numbered from stern to bow, thus K1 Kesselraum 1 was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v("’s after boiler room, T2/3 Turbinenraüme 2 and 3 were the forward engine rooms alongside each other. There were twelve oil-fired boilers aboard the ship, arranged in three boiler rooms in sections VI, VII and VIII. The Wagner was a high-pressure, hot steam, water-tube boiler with natural water circulation and two Saacke burners to each boiler. The burners were under Askania automatic control. The introduction of the high-pressure steam boilers was intended to reduce weight and need for space, lower the fuel consumption and increase manoeuvrability by faster power adjustments. The advanced boilers and the hydraulically operated regulator were complicated, however, and problems arose with the new systems from inadequate testing before the war. Further complication was the expansion of personnel and a large turnover of qualified men after the war began. Three sets of Blohm & Voss geared turbines in separate housings were contained in two turbine rooms. The turbines driving the outer shafts were together in the forward turbine-room in section V while the centre shaft was connected to the turbine in the after turbine-room in section III. Turbines and boilers were grouped together, but there were some who were critical of the chosen solution. If the boiler and turbine rooms had been arranged on the unit system, with turbines and boilers in each of the three hull sections, the propulsion system would have been less vulnerable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was equipped with three electricity plants with four diesel generators and six turbogenerators each. Total electrical output was 2,900 kW. Electrical plant 1 and turbine 1 were in section III. Electrical plant 2 was in section IV. Turbines 2 and 3 were in section V. Electrical plant 3 was in section IX. At low speed, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" was unpredictably affected by wind and currents and with rudder hard over at high speed, the ships of this class heeled up to 14 degrees and lost up to 50 per cent speed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" carried three bow anchors and one stern anchor. There were six boats aboard the ship and two cranes. The damage control organisation had three fire-fighting pumps, ten electrically driven pumps and a leak/bilge pump at its disposal. All pumps could be reversed to flood the magazines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upon completion, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" began what should have been intensive trials and working up in the Baltic. Harsh winter conditions with abundant seaice and extensive modifications, however, meant that she had only spent some twenty days at sea when it was decided to deploy her to Oslo. Neither the torpedo batteries nor the 20.3-cm guns had been fired live during the exercises. The young crew had been grouped together while she was still in the yard and they knew each other well, but few had experience from other ships – far less from war. The officers were largely inexperienced and "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("only a handful had been in battle. Emergency training, damage control and action-stations drills were deficient or at best incomplete. Manuals were under implementation, except for those of the engine room, which were still being drafted. Nevertheless, SKL saw no particular risk in assigning the new cruiser to this presumably simple task and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v("’s first and only captain, the 47-year-old Kapitän zur Zee Heinrich Woldag, was ordered to head for the Baltic with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Emden")]), _vm._v(" soon as both ships were ready.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the next level down, the second-in-command was Fregattenkapitän Erich Heymann. First Artillery Officer was Korvettenkapitän Kurt-Eduard Engelmann. Below deck, the Senior Engineering Officer, Fregattenkapitän Karl Thannemann ruled supreme."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Notes#rch1fn7",
      "id": "ch1fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab1c",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Key Officers on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blücher")]), _vm._v(" in April 1940")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Kommandant")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Captain")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KptzS Heinrich Woldag")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("I. Offizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("First officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("FKpt Erich Heymann")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("I. Artillerieoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("First gunnery officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt Kurt-Eduard Engelmann")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("II. Artillerieoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Second gunnery officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt Hans-Erik Pochhammer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("III. Artillerieoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Third gunnery officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KptLt Georg Hagene")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("FlaMWOffz.")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("AA gunnery officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("OblnzS Heinrich Wilhelm Schürdt")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Art.-technischer Offizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Artillery officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("OblnzS Friedrich Markworth")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Leitender Ingenieur")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Chief engineer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("FKpt (Ing) Karl Thannemann")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("E-Ingenieur")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Chief electrical engineer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt (Ing) Helmut Karbe")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Leckwehroffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Damage control officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt (Ing) Jürgen Engelhardt-Bergeshof")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Navigationsoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Navigation officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt Hugo Förster")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Verwaltungsoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Admin officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt Ramm")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Rollenoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Division officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KKpt Werner Czygan")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Bordnachrichtenoffizier")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Intelligence officer")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("KptLt Walter Pommerehne")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('p', {
    staticClass: "tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "tabs"
  }, [_vm._v("Adjutant")])]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_c('p', {
    staticClass: "tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "tabs"
  }, [_vm._v("Adjutants")])]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("KKpt Kurt Zöpfel")]), _vm._v(" "), _c('p', {
    staticClass: "tabs"
  }, [_vm._v("OblnzS Walter Freyberg-Eisenberg")]), _vm._v(" "), _c('p', {
    staticClass: "tabs"
  }, [_vm._v("Almendingen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("I. Schiffsarzt")]), _vm._v(" "), _c('td', {
    staticClass: "tab1"
  }, [_vm._v("Senior doctor")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Dr. Med. Bruno Kort")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1",
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "tabs1"
  }, [_vm._v("KptzS = Kapitän zur See; FKpt = Fregattenkapitän; KKpt = Korvettenkapitän; KptLt = Kapitänleutnant; OblnzS = Oberleutnant zur See")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b478fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter01.vue
// module id = 84
// module chunks = 0